// extracted by mini-css-extract-plugin
export default {"content":"UsersList_content__Mbs5W","v-align-m":"UsersList_v-align-m__fVPmS","text-a-c":"UsersList_text-a-c__ZQI1D"};